import {createSharedPathnamesNavigation} from 'next-intl/navigation';

export const locales = ['en', 'ua', 'ru', 'tr', 'it', 'es', 'de', 'cn', 'fr', 'ro', 'pl'] as const;
export const localePrefix = 'as-needed'; // always, as-needed, never

export const {Link, redirect, usePathname, useRouter} =
    createSharedPathnamesNavigation({locales, localePrefix});